import * as _ from 'underscore';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { FlowListItemInfo } from '../models/FlowInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Flows } from '../resources/Flows';
import { IResult } from '../ServerApi/types/IResponse';
import { IUserName } from '../ServerApi/types/IUser';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { IErrorDetail } from './ContentActionNotification';
import { IConfirmChangeOwnerScope } from './ContentActions';
import { SearchSuggestionsService } from './SearchSuggestionsService';

export class ChangeFlowOwnerAction {

  public static $inject = ['ActionHelpers', 'ConfirmActionDialog', '$translate', 'Flows', 'SearchSuggestionsService'];

  constructor(
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private Flows: Flows,
    private suggestions: SearchSuggestionsService) {}

  public confirmChangeOwner(flows: Set<FlowListItemInfo>, context: IActionContext): ng.IPromise<IResult> {

    const ownerPicker = {
      prompt: flows.size() === 1
      ? this.$translate.instant('changeOwnerFlowPrompt', { NAME: L10n.elideIfLong(flows.first().name) })
      : this.$translate.instant('changeOwnerFlowsPrompt', { COUNT: flows.size() }, L10n.Interpolations.Count),
      ownerQuery: (matchText: string) => this.suggestions.usersWithoutGuest(matchText),
      targetOwner: <IUserName>null
    };
    const newDialogScope = <IConfirmChangeOwnerScope> context.scope.$new();
    newDialogScope.ownerPicker = ownerPicker;

    let currentOwnerId = flows.first().owner.id;
    if(_.any(flows.toArray(), (flow: FlowListItemInfo) => (flow.owner.id !== currentOwnerId))) {
      currentOwnerId = null;
    }

    return this.ConfirmActionDialog.open({
      scope: newDialogScope,
      title: this.$translate.instant('changeOwner'),
      bodyTemplateUrl: 'changeOwnerDialog.html',
      actionName: this.$translate.instant('changeOwnerConfirm', { COUNT: flows.size() }, L10n.Interpolations.Count),

      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.Flows.setOwner(flows.keys(), ownerPicker.targetOwner.id)
          .then((result: IResult) => this.notifyResult(flows, result, ownerPicker.targetOwner.displayName));
      },
      confirmDisabled: () => !ownerPicker.targetOwner || ownerPicker.targetOwner.id === currentOwnerId
    }).result.finally(() => newDialogScope.$destroy());
  }

  private notifyResult(flows: Set<FlowListItemInfo>, result: IResult, ownerName: string) {
    this.ActionHelpers.notifyStandardError(
      flows,
      {
        successId: 'changeOwnerFlowsSuccess',
        errorId: 'changeOwnerFlowsError'
      },
      (errorItem: IErrorItem<FlowListItemInfo>) => this.errorDetailFor(errorItem),
      { OWNER_NAME: ownerName }
    )(result);
  }

  private errorDetailFor(errorItem: IErrorItem<FlowListItemInfo>): IErrorDetail {
    const itemName = errorItem.item.name;
    let errorMessage: string;

    switch (errorItem.error.code) {
      default:
        errorMessage = this.$translate.instant('errorUnknown');
    }
    return { itemName, errorMessage };
  }
}

Module.instance().service('ChangeFlowOwnerAction', ChangeFlowOwnerAction);
